<template>
  <div class="floating" v-show="visible">
    <!--吹き出し-->
    <p id="floating_primeballoon" class="floating__balloon" v-if="isFocused" @click="closeBalloon">
      <a href="/yagiprimeinfo" target="_blank" class="floating-link" @click="closeBalloon">{{ getMessage }}</a>
    </p>

    <button id="floating_prime" class="floating__btn" @click="openBalloon">
      <img src="/static/renew3_img/floating.png" alt="ヤギプライムを教えるヤギ" class="floating-img">
    </button>

    <div class="backdrop" v-show="isFocused" @click="closeBalloon"></div>

  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.floating {
  position: fixed;
  bottom: 0;
  right: 0;

  @include max-width(sm) {
    bottom: -10px;
    right: -10px;
  }

  &__balloon {
    position: relative;
    display: inline-block;
    padding: 10px;
    background: #8fbd67;
    border-radius: 10px;
    font-size: 10px;
    right: -60px;
    top: -80px;
    z-index: 99;

    &::before {
      content: '';
      position: absolute;
      left: 40px;
      bottom: -8px;
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
      border-top: 18px solid #8fbd67;
      border-bottom: 0;
      transform: rotate(-35deg);
    }

    .floating-link {
      white-space: pre-wrap;
      color: #fff;
      text-decoration: underline;
    }
  }

  &__btn {
    position: relative;
    background: none;
    padding: 0;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }

    .floating-img {
      width: 100px;
      height: auto;
    }

  }

  .backdrop {
    opacity: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

}
</style>

<script>
export default {
  data () {
    return {
      visible: false,
      isFocused: false
    }
  },
  computed: {
    getMessage () {
      const meslist = ['3分で履歴書\n作成の裏ワザ', '証明写真も\n自動透過！', 'ヤギプラって\nなに？', 'AIで面倒な\n文章も一瞬で', '履歴書作成後は\n面接練習も！']
      return meslist[Math.floor(Math.random() * meslist.length)]
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    openBalloon () {
      this.isFocused = true
    },
    closeBalloon () {
      this.isFocused = false
    },
    handleScroll () {
      this.scrollY = window.scrollY
      if (!this.visible) {
        this.visible = window.scrollY > 100
      } else if (window.scrollY < 90) {
        this.visible = !this.visible
      }
    }
  }
}
</script>
